/*!

=========================================================
* Argon Dashboard React - v1.2.4
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes, Navigate, useNavigate } from "react-router-dom";

import "assets/plugins/nucleo/css/nucleo.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "bootstrap-icons/font/bootstrap-icons.min.css";
import "assets/scss/argon-dashboard-react.scss";
import './custom.scss'

import AdminLayout from "layouts/Admin.js";
import AuthLayout from "layouts/Auth.js";
import AppContext from "AppContext";

import { useActions } from "AppContext";
import Confirmation from "components/Confirmation";
import { ToastContainer } from "react-toastify";
import Alert from "components/Alert";
import Loading from "components/Loading";
import IncluirOSSemaforica from "views/ordensServico/IncluirOSSemaforica";

function App() {
  const appContextData = useActions()

  useEffect(() => {
    document.body.classList.remove('theme-dark', 'theme-light')
    document.body.classList.add(`theme-${appContextData.state.theme}`)
  }, [appContextData.state.theme])

  return (
    <AppContext.Provider value={appContextData}>
      <BrowserRouter>
        <Routes>
          <Route path="/admin/*" element={<AdminLayout />} />
          <Route path="/auth/*" element={<AuthLayout />} />
          <Route path="/incluir_os_semaforica" element={<IncluirOSSemaforica />} />
          <Route path="*" element={<Navigate to="/admin/index" replace />} />
        </Routes>
      </BrowserRouter>
      <Confirmation />
      <Alert />
      <ToastContainer />
      <Loading />
    </AppContext.Provider>
  )
}

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(<App />);
